<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div :class="`Modal_area ${currentStep === 3 ? '_back-cl01' : ''}`">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="ログを記録モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div v-if="currentStep !== 3" class="Step__box Step__box--sm Step__box_modal">
        <div class="Step__head">
          Step
        </div>
        <div class="Step__circle_line">
          <div
            :class="`Step__circle  ft_en ${setStepActive(1)}`"
          >
            <span>1</span>
          </div>
        </div>
        <div class="Step__circle_line">
          <div :class="`Step__circle  ft_en ${setStepActive(2)}`">
            <span>2</span>
          </div>
        </div>
      </div>
      <!-- <div class="Modal_title">今のあなたを観察してみましょう</div> -->
      <div class="Modal_title">
        <span class="Modal_title_date">{{ showSelectedDate() }}</span>
      </div>
      <log-update-modal-step-1
        v-show="currentStep === 1"
        :step="currentStep"
        :detail-step1="isDetail"
        @changeStep1="changeStep1"
      />
      <log-update-modal-step-2
        v-show="currentStep === 2"
        :step="currentStep"
        :detail-step2="isDetail"
        :listzoomlogs="listZooms"
        :listmelonlogs="listMelons"
        :meditation-melontv="fullTime"
        @changeStep2="changeStep2"
      />
      <log-update-modal-step-3
        v-show="currentStep === 3"
        :step="currentStep"
        @changeStep="changeStep"
        @modalClose="modalClose"
      />
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'
import LogUpdateModalStep1 from './LogUpdateModal/LogUpdateModalStep1.vue'
import LogUpdateModalStep2 from './LogUpdateModal/LogUpdateModalStep2.vue'
import LogUpdateModalStep3 from './LogUpdateModal/LogUpdateModalStep3.vue'
import 'vue-slider-component/theme/antd.css'
import LogStore from '@/services/logService'
import moment from 'moment'

export default {
  name: 'LogUpdateModal',
  components: {
    ModalLayout,
    LogUpdateModalStep1,
    LogUpdateModalStep2,
    LogUpdateModalStep3
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Object,
      default: function() {
        return null
      }
    },
    listZooms: {
      type: Array,
      default: () => []
    },
    listMelons: {
      type: Array,
      default: () => []
    },
    fullTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentStep: 1,
      isOpenWriteStep2: false,
      heartRate: null,
      healthStatus: null,
      meditation: null,
      diary: null,
      meditationMelontv: null
    }
  },
  mounted() {},
  methods: {
    setStepActive(step) {
      return this.currentStep === step ? 'Step__circle--active' : ''
    },
    changeStep1(step, heart, health) {
      this.currentStep = step
      this.heartRate = heart
      this.healthStatus = health
    },
    changeStep2(step, meditat, logs) {
      this.currentStep = step
      this.meditation = meditat
      this.diary = logs
      this.meditationMelontv = this.fullTime
      this.updateDiary()
    },
    changeStep(step) {
      this.currentStep = step
    },
    async updateDiary() {
      const data = {
        heart_beat_rate: this.heartRate,
        health_state: this.healthStatus,
        meditation_time: this.meditation,
        diary: this.diary,
        meditation_melontv: this.meditationMelontv
      }
      const id = this.isDetail.id
      const record = {
        old_meditation: this.isDetail.meditation_time,
        total_meditation_time: this.meditation
      }
      await LogStore.update(data, id)
      // this.setValue()
      await LogStore.updateLog(record)
    },
    resetModal() {
      this.currentStep = 1
      // reset data here
    },
    modalClose(type) {
      type = (type === 'updated') || (this.currentStep === 3) ? 'updated' : 'close'
      this.$emit('close', type)
      this.resetModal()
    },
    nextStep() {
      this.isOpenWriteStep2 = true
    },
    showSelectedDate() {
      if (this.isDetail) {
        return moment(this.isDetail.created_at).format('YYYY.MM.DD (ddd)')
      }
      return null
    }
  }
}
</script>
